export function dataInRequest(params = {}) {
  return {
    type: '@mensagemSistemaoEquipamentoKm/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@mensagemSistemaoEquipamentoKm/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@mensagemSistemaoEquipamentoKm/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@mensagemSistemaoEquipamentoKm/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@mensagemSistemaoEquipamentoKm/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@mensagemSistemaoEquipamentoKm/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@mensagemSistemaoEquipamentoKm/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@mensagemSistemaoEquipamentoKm/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@mensagemSistemaoEquipamentoKm/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@mensagemSistemaoEquipamentoKm/RECORD_FILTERING',
    payload: { params },
  };
}
